/* eslint-disable react/no-multi-comp */
/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { GROUP_LIST } from './constants'

export const CREATE_NEW_ANNOUNCEMENT_TEXT = (
    <FormattedMessage
        id='announcements.card.new.text'
        defaultMessage='Вы и другие уполномоченные соклановцы можете разместить здесь объявления для всего клана.'
    />
)

export const CREATE_NEW_ANNOUNCEMENT_BUTTON = (
    <FormattedMessage
        id='announcements.card.new.button'
        defaultMessage='Разместить объявление'
    />
)

export const CREATE_NEW_ANNOUNCEMENT_BUTTON_TOOLTIP = (
    <FormattedMessage
        id='announcements.card.new.button.tooltip'
        defaultMessage='Разместить новое объявление'
    />
)

export const CREATE_NEW_ANNOUNCEMENT_ICON_TOOLTIP = (
    <FormattedMessage
        id='announcements.card.new.icon_tooltip'
        defaultMessage='Разместить новое объявление'
    />
)

export const EXTERNAL_URL_ICON_TOOLTIP = (
    <FormattedMessage
        id='announcements.card.news.icon_tooltip'
        defaultMessage='Смотреть новость на танковом портале.'
    />
)

export const LOCKED_ANNOUNCEMENT_TOOLTIP = (
    <FormattedMessage
        id='announcements.copyright.lock_icon_tooltip'
        defaultMessage='Объявление видят Командующий, Заместитель командующего, Офицер штаба и Командир подразделения.'
    />
)

export const OUT_OF_CLAN = (
    <FormattedMessage
        id='announcements.copyright.out_of_clan'
        defaultMessage='Игрок покинул клан'
    />
)

export const ANNOUNCEMENT_VIEW_TITLE = (
    <FormattedMessage
        id='announcements.view.title'
        defaultMessage='Объявление командования'
    />
)

export const ANNOUNCEMENT_CREATE_TITLE = (
    <FormattedMessage
        id='announcements.view.title.create'
        defaultMessage='Новое объявление'
    />
)

export const ANNOUNCEMENT_EDIT_TITLE = (
    <FormattedMessage
        id='announcements.view.title.edit'
        defaultMessage='Редактирование объявления'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_EDIT = (
    <FormattedMessage
        id='announcements.view.button.edit'
        defaultMessage='Редактировать'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_EDIT_TOOLTIP = (
    <FormattedMessage
        id='announcements.view.button.edit.tooltip'
        defaultMessage='Перейти к редактированию этого объявления.'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE = (
    <FormattedMessage
        id='announcements.view.button.archive'
        defaultMessage='Переместить в архив'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE_TOOLTIP = (
    <FormattedMessage
        id='announcements.view.button.archive.tooltip'
        defaultMessage='После перемещения объявления в архив, вы сможете восстановить его на клановом портале.'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_DELETE = (
    <FormattedMessage
        id='announcements.view.button.delete'
        defaultMessage='Удалить'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_DELETE_TOOLTIP = (
    <FormattedMessage
        id='announcements.view.button.delete.tooltip'
        defaultMessage='После удаления объявления вы не сможете его восстановить.'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_CREATE = (
    <FormattedMessage
        id='announcements.view.button.create'
        defaultMessage='Разместить объявление'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_CREATE_TOOLTIP = (
    <FormattedMessage
        id='announcements.view.button.create.tooltip'
        defaultMessage='Нажмите, чтобы разместить новое объявление.'
    />
)

export const ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP = (
    <FormattedMessage
        id='announcements.view.button.create.disabled_tooltip'
        defaultMessage='В клане уже размещено максимальное количество объявлений.'
    />
)

export const ANNOUNCEMENT_CREATE_BUTTON_SAVE = (
    <FormattedMessage
        id='announcements.create.button.save'
        defaultMessage='Разместить'
    />
)

export const ANNOUNCEMENT_EDIT_BUTTON_SAVE = (
    <FormattedMessage
        id='announcements.edit.button.save'
        defaultMessage='Сохранить'
    />
)

export const ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_LIMIT = (
    <FormattedMessage
        id='announcements.edit.button.save.tooltip.limit'
        defaultMessage='Превышено максимальное количество символов.'
    />
)

export const ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_FORBIDDEN = (
    <FormattedMessage
        id='announcements.edit.button.save.tooltip.forbidden'
        defaultMessage='Объявление содержит выражения, нарушающие Правила кланов.'
    />
)

export const ANNOUNCEMENT_EDIT_BUTTON_CANCEL = (
    <FormattedMessage
        id='announcements.edit.button.cancel'
        defaultMessage='Отмена'
    />
)

export const ANNOUNCEMENT_EDIT_TEXTAREA_HINT_CHARS = (charLength, maxLength) => (
    <FormattedMessage
        id='announcements.edit.textarea_hint.chars'
        defaultMessage='Символы: {charLength} / {maxLength}'
        values={{ charLength, maxLength }}
    />
)

export const ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD = (example) => (
    <FormattedMessage
        id='announcements.edit.textarea_hint.bold'
        defaultMessage='Выделение жирным: {example}'
        values={{ example }}
    />
)

export const ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_TITLE_TOOLTIP = (
    <FormattedMessage
        id='announcements.edit.textarea_hint.bold.title.tooltip'
        defaultMessage='Оформление текста'
    />
)

export const ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_BODY_TOOLTIP = (
    <FormattedMessage
        id='announcements.edit.textarea_hint.bold.body.tooltip'
        defaultMessage='Чтобы сделать текст жирным, выделите его символом «*» с двух сторон. При этом символ «*» не будет отображаться в размещённом объявлении. Чтобы несколько символов «*» или «_» отображались в объявлении, поставьте перед ними символ «{backslash}». При этом символ «{backslash}» не будет отображаться в размещённом объявлении.'
        values={{ backslash: '\\' }}
    />
)

export const ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_EXAMPLE = (
    <FormattedMessage
        id='announcements.edit.textarea_hint.bold.example'
        defaultMessage='*текст*'
    />
)

export const ANNOUNCEMENT_EDIT_GROUP_TYPE_CAPTION = (
    <FormattedMessage
        id='announcements.edit.group_type.caption'
        defaultMessage='Уровень доступа'
    />
)

export const ANNOUNCEMENT_EDIT_GROUP_TYPE_TOOLTIP = (
    <FormattedMessage
        id='announcements.edit.group_type.tooltip'
        defaultMessage='Выберите, кто сможет просмотреть это объявление.'
    />
)

export const ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS = {
    [GROUP_LIST.ALL_MEMBERS]: (
        <FormattedMessage
            id='announcements.edit.group_type.all_members'
            defaultMessage='Все игроки клана'
        />
    ),
    [GROUP_LIST.COMMAND_STAFF]: (
        <FormattedMessage
            id='announcements.edit.group_type.command_staff'
            defaultMessage='Командный состав'
        />
    ),
}

export const ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS_TOOLTIP = {
    [GROUP_LIST.ALL_MEMBERS]: (
        <FormattedMessage
            id='announcements.edit.group_type.all_members.tooltip'
            defaultMessage='Объявление смогут просмотреть все игроки клана.'
        />
    ),
    [GROUP_LIST.COMMAND_STAFF]: (
        <FormattedMessage
            id='announcements.edit.group_type.command_staff.tooltip'
            defaultMessage='Объявление смогут просмотреть только Командующий, Заместитель командующего, Офицер штаба и Командир подразделения.'
        />
    ),
}

export const ANNOUNCEMENT_EDIT_INFO = (date) => (
    <FormattedMessage
        id='announcements.edit.info'
        defaultMessage='Объявление будет перемещено в архив {date}'
        values={{ date }}
    />
)

export const ANNOUNCEMENT_EDIT_INFO_TOOLTIP = (
    <FormattedMessage
        id='announcements.edit.info.tooltip'
        defaultMessage='Изменить эту дату и восстановить объявления из архива можно на клановом портале.'
    />
)

export const ANNOUNCEMENT_EDIT_PRIVACY_CAPTION = (link) => (
    <FormattedMessage
        id='announcements.edit.privacy.caption'
        defaultMessage='В целях безопасности не указывайте здесь личную информацию о себе или о ком-либо, так как мы не сможем защитить её в соответствии с {link}'
        values={{ link }}
    />
)

export const ANNOUNCEMENT_EDIT_PRIVACY_LINK = (
    <FormattedMessage
        id='announcements.edit.privacy.link'
        defaultMessage='Политикой конфиденциальности Wargaming'
    />
)

export const ANNOUNCEMENT_CONFIRMATION_TITLE_ARCHIVE = (
    <FormattedMessage
        id='announcements.confirmation.title.archive'
        defaultMessage='Переместить объявление в архив?'
    />
)

export const ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_ARCHIVE = (
    <FormattedMessage
        id='announcements.confirmation.description.archive'
        defaultMessage='Вы сможете восстановить это объявление из архива на клановом портале.'
    />
)

export const ANNOUNCEMENT_CONFIRMATION_TITLE_DELETE = (
    <FormattedMessage
        id='announcements.confirmation.title.delete'
        defaultMessage='Удалить объявление?'
    />
)

export const ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_DELETE = (
    <FormattedMessage
        id='announcements.confirmation.description.delete'
        defaultMessage='После удаления объявления вы не сможете его восстановить.'
    />
)

export const ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_ARCHIVE = (
    <FormattedMessage
        id='announcements.confirmation.button.apply.archive'
        defaultMessage='Переместить'
    />
)

export const ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_DELETE = (
    <FormattedMessage
        id='announcements.confirmation.button.apply.delete'
        defaultMessage='Удалить'
    />
)

export const ANNOUNCEMENT_CONFIRMATION_BUTTON_CANCEL = (
    <FormattedMessage
        id='announcements.confirmation.button.cancel'
        defaultMessage='Отменить'
    />
)



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/translations.jsx